export default __webpack_public_path__ + "static/media/close-icon1.c1d04f60.svg";